import { useEffect } from 'react';

import { setAccessToken } from '~modules/auth/store/auth-actions';

import { setTenantAccessToken } from '~tenant-modules/auth/store/tenant-auth-actions';

import { resetAuthSensitiveQueries } from '~system/query/auth-query-cache';
import { store } from '~system/store/configure-store';
import { setScope } from '~system/store/scope/scope-slice';

import { ScopeType } from '~shared/types';

const readPersistedField = <T,>(
  rawValue: string | null,
  fieldKey: string,
): T | null => {
  if (!rawValue) return null;

  try {
    const persistedState = JSON.parse(rawValue) as Record<string, string>;
    const persistedField = persistedState[fieldKey];

    if (persistedField === undefined) return null;

    return JSON.parse(persistedField) as T;
  } catch {
    return null;
  }
};

export const AuthCrossTabSync = () => {
  useEffect(() => {
    const handleStorage = (event: StorageEvent) => {
      if (event.key === 'persist:auth') {
        store.dispatch(
          setAccessToken(
            readPersistedField<string | null>(event.newValue, 'accessToken'),
          ),
        );
        resetAuthSensitiveQueries();
      }

      if (event.key === 'persist:tenantAuth') {
        store.dispatch(
          setTenantAccessToken(
            readPersistedField<string | null>(event.newValue, 'accessToken'),
          ),
        );
        resetAuthSensitiveQueries();
      }

      if (event.key === 'persist:scope') {
        const scope = readPersistedField<ScopeType>(event.newValue, 'scope');

        if (scope) {
          store.dispatch(setScope(scope));
        }
      }
    };

    window.addEventListener('storage', handleStorage);

    return () => {
      window.removeEventListener('storage', handleStorage);
    };
  }, []);

  return null;
};
